/**
 * Arrow key handlers that wrap around the list: up from the first option goes to the end, down from the last row
 * goes to the start. Without interactive groups, the first child of a leading group counts as the first option.
 */
export const getListboxNavigation = ({ options, highlightedIndex, highlightedOption, interactiveGroups, moveHighlight, goHome, goEnd, }) => ({
    goUp: () => {
        if ((!interactiveGroups && (highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.type) === 'child' && highlightedIndex === 1) ||
            highlightedIndex === 0) {
            goEnd();
            return;
        }
        moveHighlight(-1);
    },
    goDown: () => {
        if (highlightedIndex === options.length - 1) {
            goHome();
            return;
        }
        moveHighlight(1);
    },
});
//# sourceMappingURL=navigation.js.map